import { render, staticRenderFns } from "./_purgeMatchLog.vue?vue&type=template&id=0aece498&scoped=true&lang=pug&"
import script from "./_purgeMatchLog.vue?vue&type=script&lang=js&"
export * from "./_purgeMatchLog.vue?vue&type=script&lang=js&"
import style0 from "./_purgeMatchLog.vue?vue&type=style&index=0&id=0aece498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aece498",
  null
  
)

export default component.exports